import UsageReport from "../components/app/Product/UsageReport";

function UsageReportPage() {
  return <UsageReport></UsageReport>;
}

export default UsageReportPage;
